import React from 'react';
import bannerImage from 'images/banner.jpeg';
import { useAuth } from 'contexts/AuthContext';

interface HeroSectionProps {
  onRegisterClick: (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onRegisterClick }) => {
  const { isAuthenticated } = useAuth();
  return (
    <section
      id="main-content"
      className="relative h-screen flex flex-col items-center justify-center text-center bg-black text-black"
    >
      <div
        style={{ backgroundImage: `url(${bannerImage})` }}
        className={`absolute inset-0 pointer-events-none bg-no-repeat bg-center bg-cover`}
      />
      {/* Cinematic gradient: transparent on top, dark on bottom */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/50 to-black pointer-events-none"></div>

      <div className="max-w-4xl w-full mx-auto px-6 relative z-10 flex flex-col items-center">
        <div className="mb-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bai font-bold mb-4 text-white tracking-tight leading-tight">
            Sinar Mas Digital Awards
          </h1>
          <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto text-white/80 font-medium leading-relaxed">
            Celebrating Innovation, Transformation & Excellence Across Sinar Mas
            Group
          </p>
        </div>

        <div className="w-full flex justify-center">
          <button
            onClick={onRegisterClick}
            className="w-full sm:w-auto sm:min-w-[280px] cursor-pointer inline-flex items-center justify-center px-16 py-4 rounded-full bg-white text-red-500 font-bai font-bold shadow-2xl hover:bg-gray-100 hover:scale-[1.03] active:scale-[0.97] transition-all duration-200 text-lg tracking-wide"
          >
            2026 Submission
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
